import { TileGroup } from "../../models/app/Tile";

export const MOCK_TILE_GROUPS: TileGroup[] = [
  {
    "id": 1,
    "course_id": 994,
    "title": "Activities",
    "position": 1,
    "column_id": 2
  }, {
    "id": 2,
    "course_id": 994,
    "title": "Course Grades",
    "position": 1,
    "column_id": 1
  }, {
    "id": 3,
    "course_id": 994,
    "title": "Learning Outcome & Predicted Grade",
    "position": 2,
    "column_id": 1
  }
]
